import React from "react";

export default function NumberInput({
  label,
  value,
  onChange,
  readOnly = false,
  placeholder = "",
  error,
}) {
  return (
    <div className="form-group">
      <label>{label}:</label>
      <input
        type="number"
        value={value}
        readOnly={readOnly}
        placeholder={placeholder}
        onChange={(e) => onChange && onChange(e.target.value)}
      />
      {error && <p className="error-text">{error}</p>}
    </div>
  );
}
